const CUSTOMER_PAYROLL_STATUS = {
  PENDING: "pending",
  FAILED: "failed",
  PAID: "paid",
  UNPAID: "un-paid",
  VOID: "void",
};

export default CUSTOMER_PAYROLL_STATUS;
